import { render } from "./FilePreview.vue?vue&type=template&id=475a4f08&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=475a4f08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475a4f08"]])

export default __exports__